import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Hoe kan ik een afspraak maken?',
      answer:
        'U kunt online een afspraak maken via onze website door op "Boek Nu" te klikken. U kunt ook bellen of WhatsApp sturen naar +32 473 18 39 27.',
    },
    {
      question: 'Wat is het annuleringsbeleid?',
      answer:
        'We vragen u vriendelijk om minimaal 24 uur van tevoren te annuleren of uw afspraak te verzetten. Dit kunnen we doen via telefoon of WhatsApp.',
    },
    {
      question: 'Moet ik vooraf betalen?',
      answer:
        'Nee, betaling wordt in de salon afgehandeld. U kunt contant of met kaart betalen.',
    },
    {
      question: 'Welke producten gebruiken jullie?',
      answer:
        'We gebruiken alleen premium professionele producten van bekende merken. Onze stylisten kunnen u adviseren over de beste producten voor uw haartype.',
    },
    {
      question: 'Heb ik allergieën, wat moet ik doen?',
      answer:
        'Het is belangrijk dat u uw stylist informeert over eventuele allergieën voordat de behandeling begint. We kunnen indien nodig een patch-test uitvoeren.',
    },
    {
      question: 'Kan ik parkeren bij de salon?',
      answer:
        'Er zijn parkeerplaatsen beschikbaar in de buurt van de salon. Vraag ons gerust om meer informatie bij het maken van uw afspraak.',
    },
    {
      question: 'Moet ik iets meenemen naar mijn afspraak?',
      answer:
        'Nee, we verzorgen alles. U hoeft alleen maar te komen en te ontspannen! Als u specifieke producten wilt gebruiken, kunt u die meenemen.',
    },
    {
      question: 'Wat als de kleur niet het gewenste resultaat oplevert?',
      answer:
        'Kleuren kunnen variëren afhankelijk van uw haartype en huidige kleur. We bespreken altijd vooraf de verwachtingen. Als het resultaat niet naar wens is, neem dan contact met ons op.',
    },
    {
      question: 'Kan ik een specifieke stylist kiezen?',
      answer:
        'Ja, bij het boeken kunt u een voorkeur aangeven voor een bepaalde stylist. We doen ons best om aan uw verzoek te voldoen, afhankelijk van beschikbaarheid.',
    },
  ];

  return (
    <div className="min-h-screen pt-24">
      <section className="py-20 bg-surface">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl sm:text-5xl font-serif font-bold text-primary tracking-tight mb-6">
            Veelgestelde Vragen
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Vind snel antwoorden op de meest gestelde vragen over onze diensten en salon.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-6">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-card border border-border rounded-sm overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-muted/20 transition-colors"
                  data-testid={`faq-question-${index}`}
                >
                  <span className="font-semibold text-primary">{faq.question}</span>
                  <ChevronDown
                    className={`w-5 h-5 text-muted-foreground transition-transform ${
                      openIndex === index ? 'transform rotate-180' : ''
                    }`}
                  />
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-4 text-muted-foreground" data-testid={`faq-answer-${index}`}>
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
